import { render } from "./Denture.vue?vue&type=template&id=488d3fa2"
import script from "./Denture.vue?vue&type=script&lang=js"
export * from "./Denture.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__